import { Icon, OptionIcon } from '@recargas-dominicanas/core/components';
import { style } from './search-bar.module.css';
import { useRef, type MouseEvent } from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function SearchBar(props: Props) {

  const { value, onChange } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  function handleClear(event?: MouseEvent<HTMLElement>) {
    event?.stopPropagation();
    onChange('');
  }

  return (
    <div 
      className={style.container}
      onClick={() => inputRef.current?.focus()}>
      <Icon 
        className={style.searchIcon} 
        icon='search'/>
      <input 
        ref={inputRef}
        className={style.input}
        value={value} 
        placeholder='Buscar producto'
        onChange={e => onChange(e.target.value)}/>
      {value.trim() &&
        <OptionIcon 
          className={style.clearIcon} 
          icon='clear'
          onClick={handleClear}/>
      }
    </div>
  );
}
